import apiClient from "./apiService";

// Fetch products
export const fetchProducts = async (
  page = 1,
  search = "",
  category_id,
  status,
  stock_level,
  gender,
  best_seller,
  min_price,
  max_price,
) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("search", search || "");
    if (category_id) params.append("category_id", category_id);
    if (status) params.append("status", status);
    if (stock_level) params.append("stock_level", stock_level);
    if (gender) params.append("gender", gender);
    if (best_seller) params.append("best_seller", best_seller);
    if (min_price) params.append("min_price", min_price);
    if (max_price) params.append("max_price", max_price);
    const response = await apiClient.get(
      `/admin/products/admin-index?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch products
export const fetchProductStats = async () => {
  try {
    const response = await apiClient.get(`/admin/products/admin-index`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get single product
export const fetchProduct = async (id) => {
  try {
    const response = await apiClient.get(`/admin/products/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create product
export const createProduct = async (data) => {
  try {
    const response = await apiClient.post("/admin/products", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update product
export const updateProduct = async (id, data) => {
  try {
    const response = await apiClient.post(`/admin/products/${id}?_method=PUT`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete product
export const deleteProduct = async (id) => {
  try {
    const response = await apiClient.delete(`/admin/products/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete product image
export const deleteProductImage = async (imageId) => {
  return apiClient.delete(`/admin/products/images/${imageId}`);
};
